import { createAction } from 'redux-actions';

export const startModuleLoad = createAction('MODULE_LOAD_START');
export const endModuleLoad = createAction('MODULE_LOAD_END');
